// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3NqCH","notes":"Notes_notes__38GDX"};